import { render, staticRenderFns } from "./LpuPhotosDialog.vue?vue&type=template&id=4f92c4e6&scoped=true&"
import script from "./LpuPhotosDialog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPhotosDialog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./LpuPhotosDialog.vue?vue&type=style&index=0&id=4f92c4e6&lang=scss&"
import style1 from "./LpuPhotosDialog.vue?vue&type=style&index=1&id=4f92c4e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f92c4e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f92c4e6')) {
      api.createRecord('4f92c4e6', component.options)
    } else {
      api.reload('4f92c4e6', component.options)
    }
    module.hot.accept("./LpuPhotosDialog.vue?vue&type=template&id=4f92c4e6&scoped=true&", function () {
      api.rerender('4f92c4e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPhotos/components/LpuPhotosDialog.vue"
export default component.exports